// api.js — accesso dati del modulo Fatturazione (fatt-v1, CONTRATTO-MVP §API).
// Pattern IDENTICO a sop-v3/api.js: fetch con Bearer da localStorage crm_token,
// base (window.PROC_CRM_API_BASE || '/api') + '/fatt', json best-effort,
// !ok ⇒ throw con l'errore del server o 'Errore <status>'.
// ESTENSIONI dichiarate rispetto a sop-v3:
//  - err.status + err.data sull'errore: l'editor distingue il 409
//    {error:'conflict', current} (CAS del contratto) dal resto;
//  - opts.raw: risposta TESTO (GET /fatture/:id/xml-preview è text/xml; il 422
//    torna JSON {error, problemi} e viene rialzato come errore strutturato).
// File PURO (niente JSX, niente side-effect): importabile da node --test.

export const TOKEN_KEY = 'crm_token';

export function getBase(win) { return (win.PROC_CRM_API_BASE || '/api'); }

export function getToken(win) {
  try { return win.localStorage.getItem(TOKEN_KEY); } catch (e) { return null; }
}

function buildError(status, data, fallback) {
  const err = new Error((data && data.error) || fallback);
  err.status = status;
  err.data = data;
  return err;
}

export async function api(win, path, opts) {
  opts = opts || {};
  const headers = { 'Content-Type': 'application/json' };
  const t = getToken(win);
  if (t) headers['Authorization'] = 'Bearer ' + t;
  const r = await win.fetch(getBase(win) + '/fatt' + path, {
    method: opts.method || 'GET',
    headers,
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  if (opts.raw) {
    const text = await r.text();
    if (!r.ok) {
      let data = null;
      try { data = JSON.parse(text); } catch (e) { /* corpo non-JSON: resta null */ }
      throw buildError(r.status, data, 'Errore ' + r.status);
    }
    return text;
  }
  let data = null;
  try { data = await r.json(); } catch (e) { /* corpo non-JSON: resta null */ }
  if (!r.ok) throw buildError(r.status, data, 'Errore ' + r.status);
  return data;
}

// Le voci di navigazione interne del modulo (nav[] della register in install.js).
export const TAB_IDS = ['nuova', 'emesse', 'clienti', 'voci', 'impostazioni'];
